import { render, staticRenderFns } from "./createUpdateUserInfo.vue?vue&type=template&id=f2181ab2&scoped=true&"
import script from "./createUpdateUserInfo.vue?vue&type=script&lang=js&"
export * from "./createUpdateUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./createUpdateUserInfo.vue?vue&type=style&index=0&id=f2181ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2181ab2",
  null
  
)

export default component.exports